import { connect } from "react-redux";

import { AuthorizationType, IUser } from "@common/models";
import Authorizations, {
  IAuthorizationsProps,
  IAuthorizationsActions
} from "./authorization";
import { updateUserAuthorizations } from "../../admin.actions";

export default connect(
  (
    _,
    { userId, authorization: authorizations }: IUser
  ): IAuthorizationsProps => ({
    userId,
    authorizations
  }),
  (dispatch): IAuthorizationsActions => ({
    updateAuthorizations: (userId: string, claims: AuthorizationType[]) =>
      dispatch(updateUserAuthorizations(userId, claims))
  })
)(Authorizations);
